import { AvatarGroup } from "components";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Button,
  Tooltip,
} from "@heroui/react";
import { Eye, ChevronDown, ChevronUp } from "assets/icons";
import { useState } from "react";
import { useActiveUsers } from "shared/contexts/users.context";
import { CalendarDots } from "@phosphor-icons/react";
interface ScheduleProps {
  specificUserId: string | null;
  setSpecificUserId: (userId: string) => void;
  onSelectFilter: (value?: string) => void;
}
export const Schedule: React.FC<ScheduleProps> = ({
  specificUserId,
  setSpecificUserId,
  onSelectFilter,
}) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [currentFilter, setCurrentFilter] = useState("Toegewezen taken");
  const { users } = useActiveUsers();
  const handleFilterClick = (label: string, value: string) => {
    onSelectFilter(value);
    setCurrentFilter(label);
  };
  return (
    <div className="flex flex-wrap items-center justify-between">
      <div className="flex items-center gap-1.5 text-lg font-medium">
        <CalendarDots weight="duotone" size={20} />
        <p>Mijn planning</p>
      </div>
      <div className="flex items-center gap-4">
        <div className="flex flex-wrap items-center gap-4">
          <AvatarGroup className="flex flex-wrap justify-start gap-1" max={30}>
            {users.map((user) => (
              <Tooltip
                key={user.id}
                id={user.id}
                content={user.first_name + " " + user.last_name}
              >
                <a
                  className={`cursor-pointer transition hover:-translate-y-1 ${
                    user.id === specificUserId
                      ? "border-2 border-brick-primary"
                      : ""
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setSpecificUserId(user.id);
                  }}
                >
                  <img
                    src={user.image_url}
                    alt={user.id}
                    className="h-8 w-8 rounded-full"
                  />
                </a>
              </Tooltip>
            ))}
          </AvatarGroup>
          <Dropdown onClose={() => setOpenDropdown(false)}>
            <DropdownTrigger>
              <Button
                startContent={<Eye className="h-[20px] w-[20px]" />}
                onClick={() => setOpenDropdown((prev) => !prev)}
                endContent={
                  !openDropdown ? (
                    <ChevronDown className="h-[20px] w-[20px]" />
                  ) : (
                    <ChevronUp className="h-[20px] w-[20px]" />
                  )
                }
                className="h-fit w-fit gap-1 border border-moss-primary bg-transparent px-2.5 py-1.5 font-medium text-moss-primary"
              >
                {currentFilter}
              </Button>
            </DropdownTrigger>
            <DropdownMenu aria-label="Filter">
              <DropdownItem
                onClick={() => handleFilterClick("Toegewezen taken", "myTasks")}
                key="myTasks"
              >
                Toegewezen taken
              </DropdownItem>
              <DropdownItem
                onClick={() =>
                  handleFilterClick("Gedelegeerde taken", "delegatedTasks")
                }
                key="delegatedTasks"
              >
                Gedelegeerde taken
              </DropdownItem>
              <DropdownItem
                onClick={() =>
                  handleFilterClick("Alle taken van persoon", "allTasks")
                }
                key="everyonesTasks"
              >
                Alle taken van persoon
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};
